export const LB_PER_KG = 2.20462;

const round = (n, step) => Math.round(n / step) * step;

// Stored values are always lb; kg is display-only.
export const lbToUnit = (lb, unit) => {
  const n = Number(lb);
  if (lb === '' || lb == null || Number.isNaN(n)) return '';
  return unit === 'kg' ? Number(round(n / LB_PER_KG, 0.05).toFixed(2)) : Number(n.toFixed(1));
};

export const unitToLb = (val, unit) => {
  const n = Number(val);
  return unit === 'kg' ? Number((n * LB_PER_KG).toFixed(3)) : n;
};

export const fmtW = (lb, unit) => `${lbToUnit(lb, unit)} ${unit}`;

export const UNIT_STEP = { lb: 5, kg: 2.5 };

// Body weight: 0.1 precision in either unit.
export const bodyToUnit = (lb, unit) => {
  const n = Number(lb);
  if (lb === '' || lb == null || Number.isNaN(n)) return '';
  return unit === 'kg' ? Math.round((n / LB_PER_KG) * 10) / 10 : Math.round(n * 10) / 10;
};

export const unitLabel = (unit) => (unit === 'kg' ? 'kg' : 'lbs');
